import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading || user === null) {
        return (
            <div
                className="min-h-screen flex items-center justify-center bg-sf-bg"
                data-testid="loading-screen"
            >
                <div className="font-display text-2xl text-navy animate-pulse">
                    Caricamento…
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;

    // Gate access on trial expiry / no active subscription
    const subActive = user.subscription_status === "active";
    const trialEnd = user.trial_ends_at ? new Date(user.trial_ends_at) : null;
    const trialActive = !!trialEnd && trialEnd.getTime() > Date.now();
    if (!subActive && !trialActive) {
        return <Navigate to="/trial-expired" replace />;
    }

    return children;
}
